"use client";

import type { RefObject } from "react";
import type { PaletteGroup, PaletteItem } from "@/lib/commandPalette";
import { PaletteResultItem } from "./PaletteResultItem";

/** Results List: the filtered groups, or the empty state for the query. */
export function PaletteResults({
  groups,
  items,
  selectedIndex,
  search,
  disabled,
  onHover,
  listRef,
}: {
  groups: PaletteGroup[];
  /** The same items flattened, giving each row its keyboard index. */
  items: PaletteItem[];
  selectedIndex: number;
  search: string;
  disabled: boolean;
  onHover: (index: number) => void;
  listRef: RefObject<HTMLDivElement | null>;
}) {
  return (
    <div
      ref={listRef}
      className="max-h-[60vh] flex-1 overflow-y-auto p-2"
      role="listbox"
    >
      {groups.length === 0 ? (
        <div className="px-4 py-8 text-center text-sm text-zinc-500">
          No matching results for &ldquo;{search}&rdquo;
        </div>
      ) : (
        groups.map((group) => {
          return (
            <div key={group.id} className="mb-2 last:mb-0">
              <div className="px-3 py-1.5 text-[11px] font-semibold tracking-wider text-zinc-500 uppercase">
                {group.label}
              </div>

              <div className="space-y-0.5">
                {group.items.map((item) => {
                  const itemFlatIndex = items.findIndex(
                    (fi) => fi.id === item.id
                  );
                  return (
                    <PaletteResultItem
                      key={item.id}
                      item={item}
                      index={itemFlatIndex}
                      selected={itemFlatIndex === selectedIndex}
                      disabled={disabled}
                      onHover={onHover}
                    />
                  );
                })}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
